import React, { useRef } from 'react';
import Lock_Ico from '../../../../Assets/Images/lock.png'
import { showToast } from '../../../../Component/Toast';
import Button from '../../../../Component/Button'

function Index(props) {

    let Email = useRef(null);

    const submitForm = e => {

		let email = Email.current.value;

		if(!email){
			showToast({
				type: 'error',
				message: "Please enter Email"
			})
			return
		}

        props.onSuccess(email)

	}

    return (
        <>
       <div className="container" style={{height: '100vh'}}>
            <div className="row justify-content-center h-100-center">
                <div className="col-md-6 pt-4">
                    <div data-aos="fade-left" className="p-3 text-center" style={{backgroundColor: '#fff', borderRadius: '1rem', maxWidth: 400, boxShadow: '0 1rem 2rem rgba(0,0,0,.5)!important', margin: 'auto'}}>
                        <img className="img-fluid mb-4" src={Lock_Ico} alt='Lock' style={{maxWidth: 80}} />
                        <h1 className="display-6 fw-bold">Set Password</h1>
                        <p>Enter your registered Email</p>
                        <div className="mt-4 mb-4">
                            <div>
                                <input ref={Email} type="email" className="form-control mb-3" placeholder="Email"/>
                                <Button onClick={submitForm} name='Next' loading={props.loading} />
                            </div>
                        </div>
                        <p className="mt-3" style={{fontSize: '0.9rem'}}>
                            <a className="text-parimary" href={`/?origin=${props.origin}`}>Back to Login</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}

export default Index;
